import { render } from "./PreviewLink.vue?vue&type=template&id=0a5997cf&scoped=true&ts=true"
import script from "./PreviewLink.vue?vue&type=script&lang=ts"
export * from "./PreviewLink.vue?vue&type=script&lang=ts"

import "./PreviewLink.vue?vue&type=style&index=0&id=0a5997cf&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a5997cf"]])

export default __exports__